import React, { useState, useEffect } from 'react';
import { Button, Grid, Box, Dialog, DialogTitle, DialogContent, makeStyles } from '@material-ui/core';
import { CORP_BLUE, FONT_SIZE_UPLOAD } from 'config/config';

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';


import UploadComponent from './UploadComponent';
import ViewHistoriaSuper from './ViewHistoriaSuper';
import UploadSolicitados from './UploadSolicitados';
import { /* getRadioMapped, */ /* selectedType, */ targetName/* , getRadioDefaultSelected */ } from '../SeguimientoReclamosUtils';
import ViewHistoriaPrestador from './ViewHistoriaPrestador';
import { toast } from '@jumbo/components/custom/Toast';
import { /* subirAdjuntos, */ obtenerAdjuntosPorFolio } from 'services/api';

import PageLoader from '@jumbo/components/custom/Spinner/pageLoader';
import ConfirmacionEnvio from './ConfirmacionEnvio';

import { WarningAmberOutlined } from '@mui/icons-material';

const addStyle = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    backgroundColor: CORP_BLUE,
    '& .MuiTypography-h6': {
      fontSize: 16,
      /* color: theme.palette.common.dark, */
      color: 'white',
      fontFamily: 'Roboto',
    },
  },
  num: {
    display: 'block',
    width: '100%',
    fontFamily: 'Roboto',
  },
  date: {
    display: 'block',
    width: '100%',
    color: 'white',
    fontWeight: 100,
    fontSize: 'small',
    fontFamily: 'Roboto',
  },
  type: {
    display: 'block',
    width: '100%',
    color: 'white',
    fontWeight: 100,
    fontSize: 'small',
    fontFamily: 'Roboto',
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const AddAntecedente = props => {
  const { openDialog = false, close, reclamo, cargarPreview, cargarPreviewSuper, /* setReload, reload,  */uploadType } = props;
  const classes = addStyle();
  const [value, setValue] = React.useState(0);
  /* const [uploadType, setUploadType] = useState(''); */
  const [files, setFiles] = useState([]);
  const [filesOtros, setFilesOtros] = useState([]);
  const [num, setNum] = useState('');
  const [loading, setLoading] = useState(true);
  const [isEnviado, setIsEnviado] = useState(false);
  const [adjuntosPrestador, setAdjuntosPrestador] = useState([]);
  const [folioDoc, setFolioDoc] = useState('');

  const isReadyToUpload = () => {
    if (uploadType === '') {
      return false;
    }
    if (uploadType === 'adjuntos') {
      let aux = true;

      if (files.length < reclamo.nom_antecedente.length) {
        aux = false;
      } else {
        reclamo.nom_antecedente.map((item, index) => {
          if (files[index] !== undefined) {
            if (files[index].file.name === undefined) {
              aux = false;
            }
          } else {
            aux = false;
          }
          return null;
        });
      }
      return aux;
    }
    if (
      uploadType === 'otroRecurso' ||
      uploadType === 'recurso' ||
      uploadType === 'infCumplimiento' ||
      uploadType === 'copiaNotificacion'
    ) {
      if (files[0] !== undefined) {
        if (files[0].file.name !== undefined) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  };

  const handleChange = (event, newValue) => {
    setFiles([]);
    setValue(newValue);
  };

  /*   const handleChangeUploadType = event => {
    setUploadType(event.target.value);
  }; */

  useEffect(() => {
    if (reclamo) {
      setNum(reclamo.n_reclamo ? reclamo.n_reclamo : 'nulo');
      let data = {
        run: reclamo.run_rec,
        folio: reclamo.n_reclamo ? reclamo.n_reclamo : 'nulo',
      };
      getAdjuntosPorFolio(data);
      /*       let aux = getRadioDefaultSelected(reclamo);
      aux.map((item, index) => {
        if (item) {
          setUploadType(item);
        }
        return null;
      }); */
      //setUploadType(getRadioDefaultSelected(reclamo))
    }
  }, [reclamo]);

  const onCloseDialog = event => {
    setLoading(true);
    setIsEnviado(false);
    setValue(0);
    setFiles([]);
    /*   setUploadType(''); */
    setFolioDoc('');
    close();
  };

  //const submit = async formData => {
  /*     subirAdjuntos(formData)
    .then(r => {
      setIsEnviado(true);
      setFolioDoc(r.data.folio_documento);
    })
    .catch(e => {
      toast.warn('Ocurrió un Error enviando los archivos');
      console.log(e);
    })
    .finally(evt => {
      setLoading(false);
      setReload(!reload);
    }); */
  // };

  const getAdjuntosPorFolio = async data => {
    obtenerAdjuntosPorFolio(data)
      .then(r => {
        setAdjuntosPrestador(r.data);
      })
      .catch(e => {
        console.error(e);
      })
      .finally(e => {
        setLoading(false);
      });
  };

  const enviarArchivos = () => {
    /*     setLoading(true);
    let archivos = [];
    let nombres = [];
    let bodyFormData = new FormData();
    files.map(item => {
      archivos.push(item.blobFile);
      nombres.push(
        JSON.stringify({
          name_type: item.name_type,
          source_name: item.source_name,
          target_name: item.target_name,
          tipo_adjunto: getTypeSelected(item.tipo),
        }),
      );
      return null;
    });

    filesOtros.map(item => {
      archivos.push(item.blobFile);
      nombres.push(
        JSON.stringify({
          name_type: item.name_type,
          source_name: item.source_name,
          target_name: item.target_name,
          tipo_adjunto: 'otro_adjunto',
        }),
      );
      return null;
    });

    archivos.map((item, index) => {
      bodyFormData.append('files', item, item.name);
      return null;
    });

    bodyFormData.append('names', '[' + nombres + ']');

    bodyFormData.append('tipo_reclamo', 'reclamos_ip');
    bodyFormData.append('folio', num);
    bodyFormData.append('rut', reclamo.run_rec);

    submit(bodyFormData); */
  };

  const getUploadType = () => {
    if (uploadType === 'adjuntos') {
      return viewUploadAdjuntos();
    }

    if (uploadType === 'otroRecurso') {
      return viewUploadOtroRecurso();
    }
  };

  const getType = () => {
    if (uploadType === 'recurso') {
      return 'REC';
    } else if (uploadType === 'infCumplimiento') {
      return 'INF';
    } else {
      return 'ANT';
    }
  };

  const getPrefix = () => {
    let auxPref = '';
    targetName.map((item, index) => {
      if (item.tipo === uploadType) {
        auxPref = item.prefix;
      }
      return null;
    });
    return auxPref;
  };

  /*   const getTypeSelected = () => {
      let auxtype = '';
      selectedType.map((item, index) => {
        if (item.tipo === uploadType) {
          auxtype = item.prefix;
        }
        return null;
      });
      return auxtype;
    }; */

  const removeAccents = str => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };

  const changeSingleFile = e => {
    let aux = [];
    let auxFile = e.target.files[0];
    const fileMb = auxFile.size / 1024 ** 2;

    if (fileMb <= 10 && auxFile.name.endsWith('.pdf')) {
      files.map((item, index) => {
        aux.push(item);
        return null;
      });

      let auxItem = {
        file: auxFile,
        blobFile: auxFile,
        source_name: auxFile.name,
        name_type: getType(),
        target_name: getPrefix(),
      };

      aux.push(auxItem);
      setFiles(aux);
    } else {
      if (!auxFile.name.endsWith('.pdf')) {
        toast.error('El archivo debe ser un PDF');
      } else {
        toast.error('El archivo debe pesar como máximo 15MB');
      }
    }
  };

  const changeSingleFileOtros = e => {
    let aux = [];
    let auxFile = e.target.files[0];
    const fileMb = auxFile.size / 1024 ** 2;

    if (filesOtros.length <= 1) {
      if (fileMb <= 10 && auxFile.name.endsWith('.pdf')) {
        filesOtros.map((item, index) => {
          aux.push(item);
          return null;
        });

        let auxItem = {
          file: auxFile,
          blobFile: auxFile,
          source_name: auxFile.name,
          name_type: 'ANT',
          target_name: 'otro',
        };

        aux.push(auxItem);
        setFilesOtros(aux);
      } else {
        if (!auxFile.name.endsWith('.pdf')) {
          toast.error('El archivo debe ser un PDF');
        } else {
          toast.error('El archivo debe pesar como máximo 15MB');
        }
      }
    } else {
      toast.error('Solo se pueden subir 2 adjuntos adicionales');
    }
  };

  const deleteSingleFile = index => {
    let aux = [];
    files.map((item, index) => {
      aux.push(item);
      return null;
    });
    aux.splice(index, 1);
    setFiles(aux);
  };

  const deleteSingleFileOtros = index => {
    let aux = [];
    filesOtros.map((item, index) => {
      aux.push(item);
      return null;
    });
    aux.splice(index, 1);
    setFilesOtros(aux);
  };

  const changeMultiFile = (e, index) => {
    let auxFile = e.target.files[0];
    const fileMb = auxFile.size / 1024 ** 2;
    if (fileMb <= 10 && auxFile.name.endsWith('.pdf')) {
      let auxItem = {
        file: auxFile,
        blobFile: auxFile,
        source_name: auxFile.name,
        name_type: getType(),
        target_name: removeAccents(reclamo.nom_antecedente[index]['adjunto'])
          .split(' ')
          .join('_')
          .toUpperCase(),
      };

      let aux = [...files];
      aux[index] = auxItem;
      setFiles(aux);
    } else {
      if (!auxFile.name.endsWith('.pdf')) {
        toast.error('El archivo debe ser un PDF');
      } else {
        toast.error('El archivo debe pesar como máximo 15MB');
      }
    }
  };

  const deleteMultiFile = index => {
    let aux = [...files];
    aux[index] = undefined;
    setFiles(aux);
  };

  const viewUploadAdjuntos = () => {
    return (
      <UploadSolicitados
        files={files}
        changeMultiFile={changeMultiFile}
        deleteMultiFile={deleteMultiFile}
        classes={classes}
        reclamo={reclamo}
        filesOtros={filesOtros}
        changeSingleFile={changeSingleFileOtros}
        deleteSingleFile={deleteSingleFileOtros}
      />
    );
  };

  const viewUploadOtroRecurso = () => {
    return (
      <UploadComponent
        classes={classes}
        titulo={'Subir nuevo Adjunto'}
        changeSingleFile={changeSingleFile}
        deleteSingleFile={deleteSingleFile}
        files={files}
      />
    );
  };

  const viewAdjuntos = () => {
    return (
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center">
        <Grid container style={{ fontSize: 16, fontFamily: 'Roboto' }} alignItems="center">
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <p>Seleccione documentos para adjuntar</p>
          </Grid>

          <Grid item xs={12}>
            {getUploadType()}
          </Grid>
        </Grid>
      </Box>
    );
  };

  const viewHistoria = () => {
    return (
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
        <Grid container style={{ fontSize: 16, fontFamily: 'Roboto' }}>
          <Grid
            item
            xs={12}
            style={{
              height: 1,
              backgroundColor: 'gray',
              marginBottom: 5,
              marginTop: 5,
            }}
          />
          <ViewHistoriaSuper reclamo={reclamo} setLoading={setLoading} cargarPreviewSuper={cargarPreviewSuper} />
          <Grid
            item
            xs={12}
            style={{
              height: 2,
              backgroundColor: CORP_BLUE,
              marginBottom: 5,
              marginTop: 5,
            }}
          />
          <ViewHistoriaPrestador
            adjuntosPrestador={adjuntosPrestador}
            setLoading={setLoading}
            cargarPreview={cargarPreview}
          />
        </Grid>
      </Box>
    );
  };

  return (
    <Dialog open={openDialog} onClose={onCloseDialog} fullWidth maxWidth="sm">
      <DialogTitle className={classes.dialogTitleRoot}>
        <label className={classes.num}> Reclamo N° {num} </label>
      </DialogTitle>
      {loading ? (
        <DialogContent dividers>
          <PageLoader />
        </DialogContent>
      ) : isEnviado ? (
        <ConfirmacionEnvio onCloseDialog={onCloseDialog} nFolioDoc={folioDoc} />
      ) : (
        <DialogContent dividers>
          <Box sx={{ width: '100%', minHeight: 350 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange}>
                <Tab label="Adjuntos" {...a11yProps(0)} />
                <Tab label="Historia" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              {viewAdjuntos()}
            </TabPanel>
            <TabPanel value={value} index={1}>
              {viewHistoria()}
            </TabPanel>
          </Box>
          <Box sx={{ width: '100%', minHeight: 25, border: 'solid 1px', borderColor: 'red', marginBottom: 15 }}>
            <Box m={2}>
              <Grid container>
                <Grid item xs={1}>
                  <WarningAmberOutlined style={{ fontSize: 40, color: '#dbd9ab' }} />
                </Grid>
                <Grid item xs={11}>
                  <p style={{ fontSize: FONT_SIZE_UPLOAD, paddingTop: 15 }}>
                    Solo se permite adjuntar 3 archivos en formato PDF, con un tamaño máximo de 15MB cada uno.
                    Para más información sobre los requisitos y características de los archivos adjuntos, consulte
                    la sección de ayuda o póngase en contacto a consultas-reclamos-ip@superdesalud.gob.cl
                  </p>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Box display="flex" justifyContent="flex-end" mb={4}>
            {value === 0 ? (
              <Button
                variant="contained"
                color="primary"
                onClick={enviarArchivos}
                style={{ marginRight: 10 }}
                disabled={!isReadyToUpload()}>
                &nbsp;
                {uploadType === 'otroRecurso' || uploadType === 'recurso'
                  ? 'Enviar Archivo'
                  : reclamo !== null && reclamo !== undefined
                    ? reclamo.nom_antecedente.length > 1
                      ? 'Enviar Archivos'
                      : 'Enviar Archivo'
                    : 'Enviar Archivo'}
                &nbsp;
              </Button>
            ) : null}
            <Button variant="outlined" color="primary" onClick={onCloseDialog}>
              &nbsp;Cerrar&nbsp;
            </Button>
          </Box>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default AddAntecedente;
